
<template>
  <div>
    <div v-if="loaded">
      <!-- Franchise Matched (This viewer has an address, and it's for this franchise location) -->
      <div
        v-if="
          userAddress && isUserFranchise && scope && addressType === 'normal'
        "
      >
        <!-- <div v-if="true"> -->
        <div class="container mx-auto bg-white p-0">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:pb-10">
            <!-- Map -->
            <div
              v-if="infoWindowContext.position.lat !== null"
              class="hidden md:block"
            >
              <!-- New map info -->
              <GoogleMap
                id="map"
                ref="Map"
                :center="infoWindowContext.position"
                :zoom="zoom"
                :draggable="draggable"
                :mapTypeControl="false"
                :streetViewControl="false"
                :rotateControl="false"
                class="mx-auto"
                :api-key="$config.public.googleApiKey"
                style="width: 100%; height: 100%"
                map-type-id="satellite"
                mapId="DEMO_MAP_ID"
              >
                <AdvancedMarker :options="markerOptions"></AdvancedMarker>
              </GoogleMap>
            </div>

            <!-- Card -->
            <div class="md:px-0 px-3 fcard hidden md:block">
              <FranchiseFranchiseeCard
                :name="signature"
                :location="franchiseInfo?.name"
                :franchiseeImageSrc="franchiseePhoto"
                :signatureImageSrc="franchiseePhoto"
                :phone="phone"
              />
              <p class="green font-bold py-4">
                We'd be happy to take care of your yard.<br />
                Here is your local care quote:
              </p>
              <p class="mt-4">
                Your address: <br />
                <strong v-if="userAddress">{{ userAddress }}</strong> &#183;
                <br />
                <a href="#"
                  @click="refModal?.show()"
                  class="font-bold change-address"
                  >Change Address</a
                >
              </p>
            </div>
          </div>
        </div>

        
        <!-- <div class="container mx-auto bg-white p-0 pb-10">
          <EnrolledAddOns />
        </div> -->

        <!-- Discount if ndc exists -->
        <div
          v-if="ndcInfo && validNdc"
          class="container mx-auto bg-white lg:px-10 p-4 pb-10"
        >
          <Discounts :discountHeader="ndcInfo.webDescription" />
        </div>

        <div class="container mx-auto pt-0">
          <PackageServiceCardList :borderOverride="pageData.service_color" :hideUnavailable="false"
            :hidePurchased="false" :packageBtn="true" size="large"  @isPackageAvailable="isPackageAvailable = $event" />
        </div>

        <div
          class="container mx-auto bg-white p-0"
          v-if="
            (featuredServices && featuredServices.length > 0) ||
            (addonUpsellServices && addonUpsellServices.length > 0) 
            "
        >

          <div class="w-full" >
            <Curves
            v-if="ndcInfo"
              background="fff"
              foreground="fff"
              location="topLeft"
              />
              
              <div class="grey-bend">

              <h2
                v-if="featuredServices && featuredServices.length > 0 && !isPackageAvailable"
                class="text-center mb-8"
              >
                Recommended Services
              </h2>

              <ServicesCardList
                v-if="featuredServices && featuredServices.length > 0 && !isPackageAvailable"
                :services="featuredServices"
                borderOverride="green"
                :hidePurchased="true"
                size="large"
              />

              <!-- Promo Banner for Franchise Matched section -->
                <div
                  v-if="webDiscount && webDiscount.value > 0"
                  id="promo"
                  class="grid grid-cols-8 gap-6"
                >
                  <div class="grid self-center">
                    <img
                      loading="lazy"
                      class="icon-truck"
                      src="~/assets/images/truck.png"
                      alt="Truck Icon"
                      style="width: 100%; height: 100%"
                    />
                  </div>
                  <div class="col-span-5">
                    <h2 class="text-white text-xs">
                      {{ webDiscount.value.toFixed(2) * 100 }}% OFF Additional Services
                    </h2>
                    <p class="text-white">
                      With the purchase of the Preferred Lawn Care Program. Discount applied to cart automatically. Some restrictions apply.
                    </p>
                  </div>
                  <div class="col-span-2 text-center grid">
                    <div class="grid content-center">
                      <NuxtLink to="/services/preferred-lawn-care-program/" class="button">Learn More</NuxtLink>
                    </div>
                  </div>
                </div>

              <span
                v-if="addonUpsellServices && addonUpsellServices.length > 0"
              >
                <h3 class="mt-10 mb-6 text-center">
                  Choose an upgrade to your lawn care plan and save!
                </h3>

                <ServicesCardList
                  :services="addonUpsellServices"
                  borderOverride="green"
                  :hidePurchased="true"
                  :isCarousel="true"
                  size="small"
                  layout="listview"
                />
              </span>
            </div>
            <Curves background="EEF1F4" foreground="fff" location="topRight" />
          </div>
        </div>

        <div class="container bg-white mx-auto p-0" v-if="false">
          <!-- Additional Services Block -->
          <div class="w-full">
            <Curves
              background="EEF1F4"
              foreground="fff"
              location="bottomRight"
            />
            <AdditionalServices />
            <Curves background="EEF1F4" foreground="fff" location="topLeft" />
          </div>
        </div>

        <div class="container mx-auto bg-white p-0 md:hidden">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:pb-10">
            <!-- Card -->
            <div class="md:px-0 px-3 fcard mb-4">
              <FranchiseFranchiseeCard
                :name="signature"
                :location="franchiseInfo.name"
                :franchiseeImageSrc="franchiseePhoto"
                :signatureImageSrc="franchiseePhoto"
                :phone="phone"
              />
              <p class="green font-bold py-4">
                We'd be happy to take care of your yard.<br />
                Here is your local care quote:
              </p>
              <p class="mt-4">
                Your address: <br />
                <strong v-if="userAddress">{{ userAddress }}</strong>
              </p>
            </div>
          </div>
        </div>

        <div class="container bg-white mx-auto pb-[5rem]">
            <FaqList :categoryId="1" :disableSchema="true" />
        </div>

        <div v-if="franchiseData" class="container bg-white mx-auto pb-1">
          <ProgramApplications
            :location="franchiseInfo.name"
            :franchiseData="franchiseData.ucmsFranchiseData"
            :perPage="2"
          />
        </div>

      </div>

      <!-- Franchise Unmatched (This viewer has an address, but we don't recognize it or it needs special services) -->
      <div
        v-else-if="
          userAddress && isUserFranchise && (!scope || addressType !== 'normal')
        "
        class="container p-0 bg-white mx-auto"
      >

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:pb-10">
          <!-- Map -->
          <div
            v-if="infoWindowContext.position.lat !== null"
            class="hidden md:block"
          >
            <!-- New map info -->
            <GoogleMap
                id="map"
                ref="Map"
                :center="infoWindowContext.position"
                :zoom="zoom"
                :draggable="draggable"
                :mapTypeControl="false"
                :streetViewControl="false"
                :rotateControl="false"
                class="mx-auto"
                :api-key="$config.public.googleApiKey"
                style="width: 100%; height: 100%"
                map-type-id="satellite"
                mapId="DEMO_MAP_ID"
              >
                <AdvancedMarker :options="markerOptions"></AdvancedMarker>
              </GoogleMap>
          </div>

          <!-- Card -->
          <div class="md:px-0 px-3 mt-4 fcard hidden md:block">
            <FranchiseFranchiseeCard
              :name="signature"
              :location="franchiseInfo.name"
              :franchiseeImageSrc="franchiseePhoto"
              :signatureImageSrc="franchiseePhoto"
              :phone="phone"
            />

            <p class="green font-bold py-4">
              We'd be happy to take care of your yard.<br />
              Here is your local care quote:
            </p>
            <p class="mt-4">
              Your address: <br />
              <strong>{{ userAddress }}</strong>
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1">
          <div class="md:px-0 px-3">
            <div class="mx-1 md:mx-8">
              <h2 class="pt-10 pb-4" v-html="addressTypeHeader"></h2>
              <p v-html="addressTypeMessage"></p>
            </div>

            <div class="px-1 md:mx-8 py-4 md:py-8">
              <form class="leadFrm">
                <div v-if="errors.length" class="red">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li
                      class="red"
                      v-for="(error, index) in errors"
                      :key="index"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </div>

                <div v-if="success">
                  <p>
                    <b>{{ success }}</b>
                  </p>
                </div>
                <div v-else>
                  <div class="grid md:grid-cols-2 md:gap-4">
                    <input
                      type="text"
                      v-model="fname"
                      name="firstname"
                      placeholder="First Name *"
                      class="w-full"
                    />

                    <input
                      type="text"
                      v-model="lname"
                      name="lastname"
                      placeholder="Last Name *"
                      class="w-full"
                    />
                  </div>
                  <input
                    type="email"
                    v-model="email"
                    name="email"
                    placeholder="Email Address *"
                    class="w-full"
                  />

                  <MaskInput
                    type="text"
                    :mask="PHONE_INPUT_MASK"
                    placeholder="Phone Number *"
                    autocomplete="tel"
                    name="phone"
                    v-model="phone_contact"
                    class="w-full"
                    required
                  />

                  <input
                    type="text"
                    v-model="staddress"
                    name="address"
                    placeholder="Street Address"
                    class="w-full"
                    required
                  />

                  <div class="grid md:grid-cols-3 gap-2">
                    <input
                      type="text"
                      v-model="city"
                      name="city"
                      placeholder="City"
                      class="w-full"
                    />

                    <select
                      v-model="state"
                      name="state"
                      class="w-full"
                      required
                    >
                      <option value="" disabled selected hidden>State</option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District Of Columbia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="OH">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </select>

                    <input
                      type="text"
                      v-model="zcode"
                      name="zipcode"
                      placeholder="Zip Code"
                      class="w-full"
                    />
                  </div>

                  <textarea
                    v-model="comments"
                    name="comments"
                    placeholder="Comments"
                    class="w-full h-40"
                  ></textarea>

                  <div class="text-center">
                    <button
                      type="submit"
                      class="mt-4"
                      @click.stop.prevent="formSubmit()"
                      :disabled="isformSubmitProcessing"
                      :class="{ 'opacity-50 cursor-not-allowed': isformSubmitProcessing }"
                    >
                      <span v-if="!isformSubmitProcessing">Submit</span>
                      <span v-else>Submitting...</span>
                    </button>
                  </div>
                </div>
              </form>
              <p class="md:hidden text-xs mt-4">
                Spring Green respects your right to privacy. We will not sell,
                rent, or loan any identifiable information regarding our
                customers to any third party. Any information you give us is
                held with the utmost care and security, and will not be used in
                ways to which you have not consented.
                <NuxtLink to="/policies/privacy-policy/">
                  Our complete privacy policy is available here.
                </NuxtLink>
              </p>
            </div>
          </div>
        </div>

        <div class="container mx-auto bg-white p-0 md:hidden pt-12">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 md:pb-10">
            <!-- Card -->
            <div class="md:px-0 px-3 fcard mb-4">
              <FranchiseFranchiseeCard
                :name="signature"
                :location="franchiseInfo.name"
                :franchiseeImageSrc="franchiseePhoto"
                :signatureImageSrc="franchiseePhoto"
                :phone="phone"
              />
              <p class="green font-bold py-4">
                We'd be happy to take care of your yard.<br />
                Here is your local care quote:
              </p>
              <p class="mt-4">
                Your address: <br />
                <strong v-if="userAddress">{{ userAddress }}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Franchise Landing Page (We don't know the address or the address is not for this franchise) -->
      <div v-else>
        <!-- <div v-if="false"> -->
        <div class="container bg-white mx-auto p-0" style="position: relative">
          <HomepageHero
            :pageData="pageData"
            :location="franchiseInfo.city_state_override"
            ref="homepageHero"
          />

          <!-- This will ONLY be here if the location has it and an address is provided -->
          <div
            v-if="webDiscount && webDiscount.value > 0"
            id="promo-container"
            class="py-6"
          >
            <div id="promo" class="grid grid-cols-8 gap-6" v-if="webDiscount && webDiscount.value > 0">
              <div class="grid self-center">
                <img
                  loading="lazy"
                  class="icon-truck"
                  src="~/assets/images/truck.png"
                  alt="Truck Icon"
                  style="width: 100%; height: 100%"
                />
              </div>
              <div class="col-span-5">
                <h2 class="text-white text-xs">
                  {{ webDiscount.value.toFixed(2) * 100 }}% OFF Additional Services
                </h2>
                <p class="text-white">
                  With the purchase of the Preferred Lawn Care Program. Discount applied to cart automatically. Some restrictions apply.
                </p>
              </div>
              <div class="col-span-2 text-center grid">
                <div class="grid content-center">
                  <NuxtLink to="/services/preferred-lawn-care-program/" class="button">Learn More</NuxtLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="container p-0 bg-white mx-auto"
          :style="webDiscount && webDiscount.value > 0 ? { marginTop: '-4rem' } : {}"
        >
          <HomepageSatisfactionGuaranteed
            :pageData="pageData"
            :franchiseePhoto="franchiseePhoto"
            :franchiseInfo="franchiseInfo"
            :signature="signature"
            ref="satisfactionGuaranteed"
          />

          <!-- <HomepageCommonLawnIssues :franchiseInfo="franchiseInfo" v-if="false" /> -->
          <!-- <HomepageReviewsCarousel :reviews="reviews" /> -->
          <!-- <Yardology :pageData="pageData" /> -->

          <!-- <Curves background="EEF1F4" foreground="fff" location="topRight" /> -->

          <ServiceAreaModule
            v-if="isPrimaryFranchisePage && serviceAreaCities.length"
            :cities="serviceAreaCities"
            :location="serviceAreaLocation"
            :center="serviceAreaMapCenter"
            :google-api-key="$config.public.googleApiKey"
          />

          <!-- Services -->
          <div
            id="location_services"
            class="grey-bend"
            v-if="services && services.length > 0"
          >
            <h2 class="h3 pb-6">
              Local lawn, pest and tree services in {{ franchiseInfo.name }}
            </h2>

            <ClientOnly>
              <Carousel
                :items-to-show="4"
                :items-to-scroll="4"
                :wrapAround="true"
              >
                <Slide v-for="(service, index) in services" :key="index">
                  <div v-if="service">
                    <div class="service-card">
                      <img
                        :src="`${urlLocation}${service.featured_image}`"
                        class="rounded w-full"
                        :alt="service.name"
                      />
                      <div class="p-2">
                        <h3>{{ service.name }}</h3>
                        <p>
                          {{ service.excerpt }}
                        </p>
                        <NuxtLink
                          :to="`/services/${service.slug}/`"
                          class="button"
                        >
                          Learn more
                        </NuxtLink>
                      </div>
                    </div>
                  </div>
                </Slide>
              </Carousel>
            </ClientOnly>
          </div>

          <!-- <Curves background="EEF1F4" foreground="fff" location="bottomRight" /> -->
          
          <div class="container bg-white mx-auto pb-[5rem]"
            :style="services && services.length > 0 ? { paddingTop: '5rem' } : {}"
          >
              <FaqList :categoryId="1" :disableSchema="true" />
          </div>

          <!-- Program Applications Slide -->
          <ProgramApplications
            v-if="franchiseData"
            :location="franchiseInfo.name"
            :franchiseData="franchiseData.ucmsFranchiseData"
            :perPage="2"
          />

          <!-- Areas Serviced -->
          <div class="container pb-8 franchise-info">
            <p>
              Spring Green {{ franchiseInfo.name }}<br />
              {{ address }} <br />
              {{ formatPhoneNumber(phone) ?? phone }}
            </p>

          </div>

          <Accreditation :total="accredTotal" :accredits="accredits" />
        </div>
      </div>
    </div>

    <AddressModal ref="addressModal" />
    <div id="isCarousel-modal"></div>
    <EmailCaptureModal />
  </div>
</template>

<script setup lang="ts">
import _ from "lodash";
import { useReCaptcha } from "vue-recaptcha-v3";
import { MaskInput } from "vue-3-mask";
import {
  formatPhoneNumber,
  getPhoneParts,
  isPhoneNumberValid,
  PHONE_INPUT_MASK,
} from "~/utils/phone";
import { useStore } from "vuex";
import type { Store } from "vuex/types/index.js";
import type State from "~/domains/store/State";
import { GoogleMap, AdvancedMarker } from "vue3-google-map";
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import type ServiceState from "~/domains/store/services/ServiceState";
import type PersistedState from "~/domains/store/PersistedState";
import type NdcInfoState from "~/domains/store/ndcInfo/NdcInfoState";
import type { FranchiseDataInfo } from "~/domains/transient/FranchiseDataInfo";
import type ScopeState from "~/domains/store/ScopeState";
import type InfoDataState from "~/domains/store/branchinfo/InfoDataState";
import { buildLocalBusinessSchema, buildFaqSchema } from "~/composables/useSeo";
import type { LocalBusinessSchemaOptions } from "~/composables/useSeo";
import {
  getTerritoryCities,
  isPrimaryFranchise,
  type TerritoryCity,
} from "~/utils/franchise-territory";

// Import Components
import Accreditation from "~/components/Accreditation.vue";
import AddressModal from "~/components/AddressModal.vue";
import Curves from "~/components/Curves.vue";
import Discounts from "~/components/Discounts.vue";
import EmailCaptureModal from "~/components/EmailCapture/EmailCaptureModal.vue";
import FranchiseFranchiseeCard from "~/components/Franchise/FranchiseeCard.vue";
import HomepageHero from "~/components/Homepage/HomepageHero.vue";
import PackageServiceCardList from "~/components/PremiumPackage/PackageServiceCardList.vue";
import ProgramApplications from "~/components/ProgramApplications.vue";
import ServicesCardList from "~/components/ServicesCardList.vue";
import FaqList from "~/components/Faqs/FaqList.vue";
import ServiceAreaModule from "~/components/Franchise/ServiceAreaModule.vue";

const {
  $axios,
  $config,
  $cookiz,
  $sg,
  $services,
  $metadata,
  $leads,
  $userContext,
  $companies,
  // $recaptcha,
} = useNuxtApp();

const store: Store<State> = useStore();
const route = useRoute();
const router = useRouter();
const refModal = useTemplateRef("addressModal");
const satisfactionGuaranteed = useTemplateRef("satisfactionGuaranteed");
const homepageHero = useTemplateRef("homepageHero");
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

const errors = ref<string[]>([]);
// const reviews = ref([]);
// const franchise = ref("");
const region = ref("");
const franchiseePhoto = ref("");
const phone_contact = ref("");
const address = ref("");
const faq = ref("");
const topics = ref([]);
const accredits = ref<string[]>([]);
const accredTotal = ref(3);
const userAddress = ref<string>("");
const scope = ref<ScopeState>();
const fname = ref("");
const lname = ref("");
const phone = ref("");
const email = ref("");
const staddress = ref("");
const city = ref("");
const state = ref("");
const zcode = ref("");
const comments = ref("");
const franchiseData = ref<FranchiseDataInfo>();
const services = ref("");
const urlLocation = ref($config.public.sgCmsImage);
const signature = ref("");
const success = ref("");
const draggable = ref(false);
const infoWindowContext = reactive({
  position: {
    lat: null,
    lng: null,
  },
});
const zoom = ref(21);
// const mapOptions = reactive({
//   panControl: false,
//   zoomControl: false,
//   mapTypeControl: false,
//   scaleControl: false,
//   streetViewControl: false,
//   overviewMapControl: false,
//   rotateControl: false,
//   mapTypeId: "satellite",
// });
const markerOptions = reactive({
  position: infoWindowContext.position,
  draggable: draggable,
});
const discountText = ref(null);
const ndcInfo = ref<NdcInfoState>();
const featuredServices = ref<ServiceState[]>([]);
const addonUpsellServices = ref([]);
const loaded = ref(false);
const isformSubmitProcessing = ref(false);
const validNdc = ref(true);
const marchexPhone = ref("");
const addressTypeData = ref(null);

const pageLoadError = ref(null);
const pageData = ref(null);
const orgData = ref<any>(null);
const localBusinessData = ref<any>(null);
const faqList = ref<any[]>([]);
const serviceAreaCities = ref<TerritoryCity[]>([]);
const serviceAreaMapCenter = ref<{ lat: number; lng: number } | null>(null);
let serviceAreaGeocodeRequest = 0;

const isPackageAvailable = ref(false);

const recaptcha = async () => {
  await recaptchaLoaded(); 
  return await executeRecaptcha("contact"); 
}
const franchiseInfo = computed(() => franchiseData.value?.franchiseData);
const isPrimaryFranchisePage = computed(() =>
  isPrimaryFranchise(franchiseInfo.value?.parent_id),
);
const serviceAreaLocation = computed(
  () => franchiseInfo.value?.city_state_override || franchiseInfo.value?.name || ""
);
const serviceData = computed(
  () => store.state.persistedState?.serviceData || {}
);
const webDiscount = computed(() => {
  const { franchiseDiscounts = [] } =
    store.state.persistedState.paymentInfo || {};
  return franchiseDiscounts.find((discount) => discount.name === "WebDiscount") || {};
});
const isUserFranchise = computed(
  () => route.params.slug === store.state.persistedState.franchise_slug
);
const addressType = computed(() => {
  const { addressInfo } = store.state.persistedState || {};
  if (!addressInfo) return "unmatched";
  if (!addressInfo.size) return "unmeasured";

  return addressInfo.size > (store.state.persistedState.branchInfo?.UPWebsite?.LargeLawnSizeStart ?? 24)
    ? "large"
    : "normal";
});
const addressTypeHeader = computed(() => {
  const titles = {
    unmatched: addressTypeData.value?.unmatched_title,
    unmeasured: addressTypeData.value?.unmeasured_title,
    large: addressTypeData.value?.large_lawn_title,
  };
  return titles[addressType.value];
});
const addressTypeMessage = computed(() => {
  const messages = {
    unmatched: addressTypeData.value?.unmatched_message,
    unmeasured: addressTypeData.value?.unmeasured_message,
    large: addressTypeData.value?.large_lawn_message,
  };
  return formatAddressTypeMessage(messages[addressType.value] || "");
});

watch(serviceData, (newValue, oldValue) => {
  getServices();
});

watch(pageData, (newValue, oldValue) => {
  if (!!newValue) {
    nextTick(() => {
      satisfactionGuaranteed.value?.resize();
      homepageHero.value?.resize();
    });
  }
});

const formSubmit = async () => {
  if(isformSubmitProcessing.value) {
    return;
  }

  isformSubmitProcessing.value = true;

  errors.value = [];

  // Validate required fields
  if (!fname.value) errors.value.push("First Name Required");
  if (!lname.value) errors.value.push("Last Name Required");
  if (!email.value) {
    errors.value.push("Email required.");
  } else if (!validEmail(email.value)) {
    errors.value.push("Valid email required.");
  }
  if (!phone_contact.value) {
    errors.value.push("Phone number required");
  } else if (!isPhoneNumberValid(phone_contact.value)) {
    errors.value.push(`Phone number format needs to be ${PHONE_INPUT_MASK}`);
  }
  if (!staddress.value) errors.value.push("Address required");
  if (!city.value) errors.value.push("City required");
  if (!state.value) errors.value.push("State required");
  if (!zcode.value) errors.value.push("Zipcode required");
  

  if (errors.value.length > 0) {
    isformSubmitProcessing.value = false;
    return false;
  }

  const phoneParts = getPhoneParts(phone_contact.value);

  const data = {
    firstName: fname.value,
    lastName: lname.value,
    emailAddress: email.value,
    areaCode: phoneParts?.areaCode ?? "",
    phonePrefix: phoneParts?.phonePrefix ?? "",
    phoneNumber: phoneParts?.phoneNumber ?? "",
    address: staddress.value,
    city: city.value.trim(),
    state: state.value,
    zipCode: zcode.value,
    contactType: "GENERAL_CONTACT",
    status: "NOT_APPLICABLE",
    comments: comments.value,
  };

  const verifyRecaptchaAndSubmitForm = async (data) => {
    isformSubmitProcessing.value = true;

    try {
      const token = await recaptcha(); 
      if (!token) {
        errors.value.push("Invalid reCAPTCHA.\nPlease try again.");
        return false; 
      }
      // await $recaptcha.ready(() => {
      //   $recaptcha.execute("submit").then(async (token) => {
          const form = await $leads.submitContactForm(data);

          if (!!form.id) {
            success.value =
              "Thank you for contacting us. Someone will get back with you shortly.";
          } else {
            errors.value.push("Form submission failed. Please try again.");
          }
      //   });
      // });
    } catch (error) {
      errors.value.push(
        "An error occurred during form submission. Please try again."
      );
    } finally {
      isformSubmitProcessing.value = false;
      scrollToTop();
    }
  };

  await verifyRecaptchaAndSubmitForm(data);
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const validEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const getAddressDetails = async (persistedState: PersistedState) => {
  if (!persistedState?.userAddress) return;

  const persistedUserAddress = persistedState.userAddress;

  if (typeof persistedUserAddress === "object") {
    userAddress.value = `${persistedUserAddress.address1}, ${persistedUserAddress.city}, ${persistedUserAddress.state} ${persistedUserAddress.zip}`;
    staddress.value = persistedUserAddress.address1;
    city.value = persistedUserAddress.city;
    state.value = persistedUserAddress.state;
    zcode.value = persistedUserAddress.zip;
  } else {
    userAddress.value = persistedUserAddress;
    const [localAddress, localCity, localState, localZCode] = persistedUserAddress.split(",");
    staddress.value = localAddress?.trim();
    city.value = localCity?.trim();
    state.value = localState?.trim();
    zcode.value = localZCode?.trim();
  }

  if (!persistedState.addressInfo && userAddress.value.includes(",")) {
    try {
      const addressRequestData = $sg.getAddressSearchObject(userAddress.value);
      const { data } = await $axios.post(
        `${$config.public.sgApiUrl}Addresses/SG/Search?track=true&useFranchizeZipAssignments=false`,
        addressRequestData,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      if (data?.length > 0) {
        store.commit("SET_ADDRESS_INFO", data[0]);
      }
    } catch (err) {
      console.error(err);
    }
  }

  if (addressType.value !== "normal") {
    try {
      addressTypeData.value = await $sg.getOctoberData("pages/outofarea");
    } catch (err) {
      console.error(err);
    }
  }

  if (userAddress.value) {
    try {
      const { data } = await $axios.get(
        "https://maps.googleapis.com/maps/api/geocode/json",
        {
          params: {
            address: userAddress.value,
            key: $config.public.googleApiKey,
          },
        }
      );

      if (data?.results?.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        infoWindowContext.position.lat = lat;
        infoWindowContext.position.lng = lng;

        if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(userAddress.value)) {
          zoom.value = 14;
        }
      }
    } catch (err) {
      console.error(err);
    }
  }
};

const getServices = async () => {
  const allServiceIds = franchiseInfo.value?.services_to_display ?? [];

  // Check if NDC product ID is valid
  const ndcProductId = ndcInfo.value?.product?.id?.toString();
  const ndcExtraServiceId =
    ndcInfo.value?.product?.extraService?.id?.toString();

  validNdc.value =
    allServiceIds.includes(ndcProductId) ||
    allServiceIds.includes(ndcExtraServiceId) || (ndcInfo.value?.pricingRule === "Package");

  // Get and sort featured services
  featuredServices.value = $services.getServicesByIds([2, 3], true, false);
  $services.sortServices(featuredServices.value);

  // Get, sort, and categorize add-on and upsell services
  const addonUpsellServiceIds = allServiceIds.filter(
    (serviceId) => !["2", "3"].includes(serviceId)
  );
  const localAddonUpsellServices = $services.getServicesByIds(addonUpsellServiceIds, true, false);
  $services.sortServices(localAddonUpsellServices);
  addonUpsellServices.value = localAddonUpsellServices;

};

const getNdcDetails = async (persistedState: PersistedState) => {
  if (persistedState.ndcInfo) {
    ndcInfo.value = persistedState.ndcInfo;
    return;
  }

  if (persistedState.cust_No && persistedState.scope.id) {
    try {
      const ndcInfoData = await $sg.getApiData(
        `Offers/Customer/${persistedState.cust_No}/Offer/Latest?onlyReturnServiceOffers=false`,
        persistedState.scope.id
      );

      if (ndcInfoData && !ndcInfoData.isExpired) {
        $sg.updateScope(
          this,
          persistedState.scope.id,
          persistedState.scope.sqldbid,
          persistedState.scope.custNo,
          persistedState.scope.orderId,
          ndcInfoData.ndc
        );
        store.commit("SET_NDC_INFO", ndcInfoData);
        ndcInfo.value = ndcInfoData;
      }
    } catch (error) {
      console.error("Error fetching NDC details:", error);
    }
  }
};

const formatAddressTypeMessage = (message) => {
  return message?.replace(/{{MarchExPhone}}/gi, marchexPhone.value);
};

/**
 * Parse opening hours from FranchiseDataState day-level boolean / time fields.
 * Returns an array of OpeningHoursSpecification entries for days marked as open.
 * If time strings are empty the day is still listed with default business hours.
 */
const buildOpeningHoursSpec = (fd: Record<string, any>) => {
  const dayMap: Array<{ key: string; schemaDay: string }> = [
    { key: "monday", schemaDay: "Monday" },
    { key: "tuesday", schemaDay: "Tuesday" },
    { key: "wednesday", schemaDay: "Wednesday" },
    { key: "thursday", schemaDay: "Thursday" },
    { key: "friday", schemaDay: "Friday" },
    { key: "saturday", schemaDay: "Saturday" },
    { key: "sunday", schemaDay: "Sunday" },
  ];

  const DEFAULT_OPEN = "08:00";
  const DEFAULT_CLOSE = "17:00";

  const specs: LocalBusinessSchemaOptions["openingHoursSpecification"] = [];
  for (const { key, schemaDay } of dayMap) {
    if (fd[`is_open_${key}`]) {
      specs.push({
        dayOfWeek: schemaDay,
        opens: fd[`${key}_time_open`] || DEFAULT_OPEN,
        closes: fd[`${key}_time_close`] || DEFAULT_CLOSE,
      });
    }
  }
  return specs.length > 0 ? specs : undefined;
};

/**
 * Look up an InfoData field value from the BranchInfo.InfoData array
 * (matches on FieldName, case-insensitive).
 */
const getInfoDataField = (infoData: InfoDataState[] | undefined, fieldName: string): string | undefined => {
  if (!infoData?.length) return undefined;
  return infoData.find((f) => f.FieldName?.toLowerCase() === fieldName.toLowerCase())?.FieldValue ?? undefined;
};

const getFranchiseAddress = (franchise: FranchiseDataInfo | undefined): string => {
  if (!franchise) return "";

  let street = franchise.fields?.streetAddress?.FieldValue;
  let city = franchise.fields?.city?.FieldValue;
  let state = franchise.fields?.state?.FieldValue;
  let zip = franchise.fields?.zipcode?.FieldValue;

  if (!street || !city || !state || !zip) {
    const infoData = (franchise.branchInfo as any)?.BranchInfo?.InfoData as
      | InfoDataState[]
      | undefined;
    street = street || getInfoDataField(infoData, "Mailing Address");
    city = city || getInfoDataField(infoData, "Mailing City");
    state = state || getInfoDataField(infoData, "Mailing State");
    zip = zip || getInfoDataField(infoData, "Mailing Zip Code");
  }

  const addressParts = [street, city, state, zip].map((part) => part?.trim() || "");
  return addressParts.every(Boolean) ? addressParts.join(", ") : "";
};

const getServiceAreaMapCenter = async () => {
  const address = getFranchiseAddress(franchiseData.value);
  const requestId = ++serviceAreaGeocodeRequest;

  if (!address || !$config.public.googleApiKey) {
    serviceAreaMapCenter.value = null;
    return;
  }

  try {
    const { data } = await $axios.get(
      "https://maps.googleapis.com/maps/api/geocode/json",
      {
        params: {
          address,
          key: $config.public.googleApiKey,
        },
      },
    );

    if (requestId !== serviceAreaGeocodeRequest) return;

    const location = data?.status === "OK"
      ? data.results?.[0]?.geometry?.location
      : undefined;
    const hasValidCoordinates =
      Number.isFinite(location?.lat) && Number.isFinite(location?.lng);

    serviceAreaMapCenter.value = hasValidCoordinates
      ? { lat: location.lat, lng: location.lng }
      : null;
  } catch (error) {
    if (requestId === serviceAreaGeocodeRequest) {
      serviceAreaMapCenter.value = null;
    }
    console.error(error);
  }
};

/**
 * Collect non-empty sameAs links from franchise CMS data.
 * Filters out empty strings, null, and whitespace-only values.
 */
const collectSameAsLinks = (franchiseData: Record<string, any>): string[] => {
  const links: string[] = [];
  if (franchiseData?.schema_sameas?.length) {
    for (const item of franchiseData.schema_sameas) {
      const val = typeof item === "string" ? item : item?.value;
      if (val && val.trim()) links.push(val.trim());
    }
  }
  return links;
};

// SSR-friendly data load: franchise + page + org/local business + aggregate rating
const {
  data: initialData,
  error: initialError,
} = await useAsyncData(
  computed(() => `lawn-location-${String(route.params.slug)}`),
  async () => {
    const slug = String(route.params.slug);
    const userFranchiseData = $sg.getUserFranchiseDataCookie($cookiz, slug);

  const [page, franchise, orgRaw, faqsRaw] = await Promise.all([
    $sg.getOctoberData("pages/homepage"),
    $sg.getAllFranchiseDataAsync(
      slug,
      userFranchiseData ? userFranchiseData.branchCode : false,
      userFranchiseData ? userFranchiseData.franchiseId : false,
      false
    ),
    $metadata.getOrganizationStructuredData(),
    $companies.getUCMSAdminFAQ({
      categoryId: 1,
      sqldbid: 0,
      uP_ServiceDefinition_IDs: [],
    }),
  ]);

  if (!franchise || _.isEmpty(franchise)) {
    return navigateTo("/out-of-area");
  }

  if (franchise.redirectSlug) {
    return navigateTo(`/lawn-care-locations/${franchise.redirectSlug}`);
  }

  // Fetch aggregate rating for this branch (may return undefined)
  const aggRatingRaw = await $metadata.getAggregateRatingStructuredData(franchise.branchCode || "");
  let parsedAggRating: Record<string, any> | null = null;
  if (aggRatingRaw) {
    try {
      const parsed = typeof aggRatingRaw === "string" ? JSON.parse(aggRatingRaw) : aggRatingRaw;
      if (parsed?.ratingValue || parsed?.aggregateRating?.ratingValue) {
        // The CMS may return a full wrapper or just the rating object
        parsedAggRating = parsed.aggregateRating || parsed;
      }
    } catch { /* ignore parse failures */ }
  }

  const orgObj = JSON.parse(orgRaw) || {};
  let localBusinessObj: Record<string, any> | null = null;

  const frontEndHost = ($config.public.frontEndUrl || "").replace(/\/$/, "");
  const canonicalUrl = frontEndHost ? `${frontEndHost}/lawn-care-locations/${slug}/` : `/lawn-care-locations/${slug}/`;

  orgObj.name = orgObj.name || "Spring Green";
  orgObj.alternateName = orgObj.alternateName || "Spring Green";
  orgObj.description =
    orgObj.description ||
    franchise.franchiseData.meta_description ||
    franchise.franchiseData.excerpt;

  if (!orgObj.telephone && franchise.fields?.phone?.FieldValue) {
    const re = /[\(\)\s-]/g;
    orgObj.telephone =
      "+1" + franchise.fields.phone.FieldValue.replaceAll(re, "");
  }

  // --- Resolve address components ---
  // Primary source: franchise.fields (from CMS)
  let addrStreet = franchise.fields?.streetAddress?.FieldValue;
  let addrCity = franchise.fields?.city?.FieldValue;
  let addrState = franchise.fields?.state?.FieldValue;
  let addrZip = franchise.fields?.zipcode?.FieldValue;

  // Fallback: parse from BranchInfo.InfoData (Mailing Address fields)
  if (!addrStreet || !addrCity || !addrState || !addrZip) {
    const infoData = (franchise.branchInfo as any)?.BranchInfo?.InfoData as InfoDataState[] | undefined;
    if (infoData?.length) {
      addrStreet = addrStreet || getInfoDataField(infoData, "Mailing Address");
      addrCity = addrCity || getInfoDataField(infoData, "Mailing City");
      addrState = addrState || getInfoDataField(infoData, "Mailing State");
      addrZip = addrZip || getInfoDataField(infoData, "Mailing Zip Code");
    }
  }

  const hasAddress = !!(addrStreet && addrCity && addrState && addrZip);

  if (!orgObj.address && hasAddress) {
    orgObj.address = {
      "@type": "PostalAddress",
      streetAddress: addrStreet,
      addressLocality: addrCity,
      addressRegion: addrState,
      postalCode: addrZip,
      addressCountry: "US",
    };
  }

  // --- Collect sameAs links (filtered, no empty strings) ---
  const franchiseSameAs = collectSameAsLinks(franchise.franchiseData);

  // --- Build opening hours specification from per-day flags ---
  const openingHoursSpec = buildOpeningHoursSpec(franchise.franchiseData);

  // --- Resolve founding date from InfoData ---
  const infoDataForFoundingYear = (franchise.branchInfo as any)?.BranchInfo?.InfoData as InfoDataState[] | undefined;
  const foundingYear = getInfoDataField(infoDataForFoundingYear, "Franchise Start Year");

  // --- Build enriched LocalBusiness structured data ---
  const franchiseePhotoSrc = franchise.franchiseData
    .franchise_owner_image
    ? `${$config.public.sgCmsImage}${franchise.franchiseData.franchise_owner_image}`
    : "";
  const isPrimaryFranchisePage = isPrimaryFranchise(
    franchise.franchiseData.parent_id,
  );

  if (hasAddress) {
    const territoryCities = getTerritoryCities(franchise.branchCode);
    const lbOptions: LocalBusinessSchemaOptions = {
      name: "Spring Green",
      id: `${canonicalUrl}#localbusiness`,
      description: franchise.franchiseData.meta_description || franchise.franchiseData.excerpt,
      url: canonicalUrl,
      image: franchiseePhotoSrc || undefined,
      telephone: orgObj.telephone,
      address: {
        streetAddress: addrStreet,
        addressLocality: addrCity,
        addressRegion: addrState,
        postalCode: addrZip,
        addressCountry: "US",
      },
      priceRange: "$$",
      areaServed:
        isPrimaryFranchisePage && territoryCities.length > 0
          ? territoryCities.map((city) => ({
              "@type": "City" as const,
              name: city.name,
              ...(city.state
                ? { containedInPlace: { "@type": "State", name: city.state } }
                : {}),
            }))
          : undefined,
      sameAs: franchiseSameAs.length > 0 ? franchiseSameAs : undefined,
      openingHoursSpecification: openingHoursSpec,
      foundingDate: foundingYear || undefined,
      // Reference the site-wide OfferCatalogs by @id (catalogs are emitted
      // top-level on their respective /services/* listing pages, so we avoid
      // duplicating the full catalog payload here).
      hasOfferCatalog: [
        { "@id": `${frontEndHost}/services/lawn-care-services/#offercatalog` },
        { "@id": `${frontEndHost}/services/tree-and-shrub-services/#offercatalog` },
        { "@id": `${frontEndHost}/services/pest-services/#offercatalog` },
      ],
    };

    // Attach aggregate rating inside LocalBusiness if available
    if (parsedAggRating?.ratingValue) {
      lbOptions.aggregateRating = {
        ratingValue: parsedAggRating.ratingValue,
        reviewCount: parsedAggRating.reviewCount,
        bestRating: parsedAggRating.bestRating,
        worstRating: parsedAggRating.worstRating,
      };
    }

    localBusinessObj = buildLocalBusinessSchema(lbOptions);
  }

  const schemaFields = [
    "schema_id",
    "schema_name",
    "schema_url",
    "schema_address_locality",
    "schema_address_region",
    "schema_address_country",
    "schema_postal_code",
    "schema_street_address",
    "schema_logo",
    "schema_description",
  ];

  schemaFields.forEach((field) => {
    if (franchise.franchiseData[field]) {
      const prop = field.replace("schema_", "");
      if (prop === "id") orgObj["@id"] = franchise.franchiseData[field];
      else if (
        prop === "addressLocality" ||
        prop === "addressRegion" ||
        prop === "addressCountry" ||
        prop === "postalCode" ||
        prop === "streetAddress"
      ) {
        orgObj["address"] = orgObj["address"] || {};
        orgObj["address"][prop] = franchise.franchiseData[field];
      } else {
        orgObj[prop] = franchise.franchiseData[field];
      }
    }
  });

  // Merge sameAs into Organization (initialize array if missing, filter empties)
  if (!orgObj.sameAs) {
    orgObj.sameAs = [];
  }
  if (Array.isArray(orgObj.sameAs)) {
    orgObj.sameAs.push(...franchiseSameAs);
    // Deduplicate and remove empty strings
    orgObj.sameAs = [...new Set(orgObj.sameAs as string[])].filter((s) => s && s.trim());
    if (orgObj.sameAs.length === 0) {
      delete orgObj.sameAs;
    }
  }

  // Persist branch info server-side
  userFranchiseData.branchCode = franchise.branchCode;
  userFranchiseData.franchiseId = franchise.franchiseId;
  $sg.saveUserFranchiseDataCookie($cookiz, userFranchiseData);

  const faqListPayload = Array.isArray(faqsRaw) && !(faqsRaw as any)?.error ? faqsRaw : [];

    return {
    pageData: page,
    franchiseData: franchise,
    orgData: orgObj,
    localBusinessData: localBusinessObj,
    franchiseePhoto: franchiseePhotoSrc,
    faqList: faqListPayload,
    serviceAreaCities: getTerritoryCities(franchise.branchCode),
    };
  },
);

/** Extract franchise fields into reactive refs */
const extractFranchiseFields = (data: FranchiseDataInfo) => {
  const { fields, franchiseData: fd } = data;
  if (fields) {
    signature.value = fields.signature?.FieldValue || "";
    region.value = fields.marketRegion?.FieldValue || "";
    phone.value = fields.phone?.FieldValue || "";
    address.value = `${fields.streetAddress?.FieldValue || ""}, ${fields.city?.FieldValue || ""}, ${fields.state?.FieldValue || ""}, ${fields.zipcode?.FieldValue || ""}`;
  }

  // Process accreditation info
  const accreditsMap: string[] = (fd?.forever_franchise_text ?? "")
    .split("[")
    .slice(1);
  if (accreditsMap.length > 0) {
    accredits.value = accreditsMap.map((element) =>
      element.split("AandA: ")[1]?.replace('\\"]', "") || ""
    );
    accredTotal.value = accreditsMap.length;
  }
};

/** Process initial async data payload - handles SSR, hydration, and client navigation */
const processInitialData = () => {
  const payload = initialData?.value;
  if (!payload || (payload as any).path) return false; // No data or redirect

  pageData.value = payload.pageData || null;
  franchiseData.value = payload.franchiseData;
  orgData.value = payload.orgData;
  localBusinessData.value = payload.localBusinessData;
  franchiseePhoto.value = payload.franchiseePhoto;
  faqList.value = Array.isArray((payload as any).faqList) ? (payload as any).faqList : [];
  serviceAreaCities.value = Array.isArray((payload as any).serviceAreaCities)
    ? (payload as any).serviceAreaCities
    : [];

  if (franchiseData.value && !_.isEmpty(franchiseData.value)) {
    extractFranchiseFields(franchiseData.value);
    loaded.value = true;
  }

  return true;
};

// Process initial data and set SEO - runs during SSR and hydration
processInitialData();
watch(initialData, () => {
  if (processInitialData()) {
    serviceAreaMapCenter.value = null;
  }
});

// SEO must be set at top-level for SSR
if (franchiseData.value) {
  const fd = franchiseData.value.franchiseData;
  const seoTitle = fd?.seo_title || fd?.title;
  const seoDescription = fd?.meta_description || fd?.excerpt;
  const socialImage = fd?.social_image ? `${$config.public.sgCmsImage}${fd.social_image}` : franchiseePhoto.value;
  const canonicalPath = route.path.endsWith("/") ? route.path : `${route.path}/`;
  const frontEndHost = ($config.public.frontEndUrl || "").replace(/\/$/, "");

  // Build FAQPage schema from the same UCMS FAQ list rendered by <FaqList :categoryId="1" />
  const faqItems = (faqList.value || [])
    .filter((item: any) => item?.Question && item?.Answer)
    .map((item: any) => ({ question: item.Question, answer: item.Answer }));
  const faqSchema = faqItems.length > 0 ? buildFaqSchema({ faqs: faqItems }) : null;

  useSeoHead({
    title: seoTitle,
    description: seoDescription,
    robotsIndex: fd?.meta_robots_index,
    robotsFollow: fd?.meta_robots_follow,
    openGraph: {
      title: fd?.social_title || seoTitle,
      description: fd?.social_description || seoDescription,
      image: socialImage,
      url: frontEndHost ? `${frontEndHost}${canonicalPath}` : canonicalPath,
      type: "website",
    },
    twitter: {
      title: fd?.social_title || seoTitle,
      description: fd?.social_description || seoDescription,
      image: socialImage,
      card: "summary_large_image",
    },
    canonicalPath,
    orgData: orgData.value,
    localBusinessData: localBusinessData.value,
    structuredData: faqSchema ? [faqSchema] : undefined,
  });
} else {
  // Fallback SEO when franchise data is unavailable (error case)
  const canonicalPath = route.path.endsWith("/") ? route.path : `${route.path}/`;
  useSeoHead({
    title: "Lawn Care Location | Spring-Green",
    description: "Professional lawn care, pest control and tree care services from Spring-Green.",
    canonicalPath,
  });
}

onMounted(async () => {
  try {
    store.state.showLoading = true;
    if (initialError?.value) {
      pageLoadError.value = initialError.value as any;
      return;
    }

    // Handle redirect case
    if (initialData?.value && (initialData.value as any).path) {
      return;
    }

    // Re-process initial data if it wasn't available during SSR/hydration
    if (!franchiseData.value) {
      processInitialData();
    }

    if (!franchiseData.value) {
      return;
    }

    watch(
      () => getFranchiseAddress(franchiseData.value),
      () => {
        void getServiceAreaMapCenter();
      },
      { immediate: true },
    );

    // Set branchCode in store before refreshing user context
    if (franchiseData.value?.branchCode) {
      store.commit("SET_BRANCHCODE", franchiseData.value.branchCode);
    }

    // Refresh user context metadata
    await $userContext.metaRefresh({
      refresh: new Set(["BRANCH_INFO", "PAYMENT_INFO", "ORDER_INFO", "SERVICE_INFO", "PACKAGE_INFO"]),
    });

    const persistedState = store.state.persistedState;
    const {
      branchMarchExPhone,
      franchiseData: persistedFranchiseData,
      branchInfo,
    } = persistedState;

    scope.value = persistedState.scope;
    marchexPhone.value = branchMarchExPhone?.FieldValue;

    // Override franchiseData from persisted state (for returning users)
    if (isUserFranchise.value && persistedFranchiseData && franchiseData.value) {
      const initialParentId = franchiseData.value.franchiseData.parent_id;
      franchiseData.value.franchiseData = {
        ...franchiseData.value.franchiseData,
        ...persistedFranchiseData,
        parent_id: initialParentId,
      };
      franchiseePhoto.value = persistedFranchiseData.franchise_owner_image
        ? `${$config.public.sgCmsImage}${persistedFranchiseData.franchise_owner_image}`
        : undefined;
      extractFranchiseFields(franchiseData.value);
    }

    // Load async operations in parallel
    await Promise.all([
      getAddressDetails(persistedState),
      getNdcDetails(persistedState),
    ]);

    if (branchInfo) {
      const { BranchInfo, BranchFAQ } = branchInfo;
      discountText.value = BranchInfo?.DefaultOffer;

      if (BranchFAQ) {
        topics.value = [
          ...new Set(Object.values(BranchFAQ).map((item) => item.Topic)),
        ];
        faq.value = BranchFAQ;
      }
    }

    await getServices();
    loaded.value = true;
  } catch (error) {
    console.error("Error in mounted hook:", error);
  } finally {
    store.state.showLoading = false;
  }
});
</script>

<style scoped>
:root {
  --green-light: #4da43a;
  --green-dark: #25590b;
  --white: #fff;
  --green-primary: #00810e;
  --font-family-primary: Poppins, sans-serif;
  --font-weight-bold: bold;
}

#promo {
  border-radius: 30px;
  padding: 25px 30px;
  background: linear-gradient(
    180deg,
    var(--green-light) 0%,
    var(--green-dark) 100%
  );
  color: var(--white) !important;
  width: 90%;
  margin: 0 auto;
  z-index: 1;
  position: relative;
}

#promo h2 {
  margin: 0 0 5px;
  line-height: 1;
  font-size: 36px;
}

#promo p {
  margin: 0;
}

#promo .button {
  background: var(--white);
  color: var(--green-primary);
  border-radius: 20px;
  display: inline-block;
  line-height: 36px;
}

.grey-bend {
  padding: 50px 30px;
}

.review-card {
  height: 80px;
}

@media (max-width: 900px) {
  #promo h2 {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  #promo {
    grid-template-columns: 1fr;
    text-align: center;
    padding: 20px;
  }

  #promo > div,
  #promo .col-span-5,
  #promo .col-span-2 {
    grid-column: span 1 / span 1;
  }

  #promo .icon-truck {
    max-width: 80px;
    margin: 0 auto;
  }

  #promo .button {
    margin: 0 auto;
  }
}

select {
  background: var(--white);
}

button {
  width: 300px;
  height: 40px;
  background: var(--green-primary);
  border-radius: 100px;
  font-family: var(--font-family-primary);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: var(--white);
}
</style>